import DepartureInfoModal from './DepartureInfoModal'

export default DepartureInfoModal
